import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setLanguage, t } from "../i18n";
import styles from "./loginform.module.css";
import DarkModeToggle from "./DarkModeToggle";
import ErrorModal from "./ErrorModal";
import LogoEn from "../assets/logo_punchline_en.png";
import LogoZh from "../assets/logo_punchline_zh.png";

const LoginForm = ({ setLoggedIn }) => {
  const [languageState, setLanguageState] = useState(sessionStorage.getItem("language") || "en");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const submitHandler = (event) => {
    event.preventDefault();

    fetch(process.env.REACT_APP_API_PATH + "/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.userID) {
          // Set token and user ID in sessionStorage.
          sessionStorage.setItem("token", result.token);
          sessionStorage.setItem("user", result.userID);

          // This keeps tracks of the login count
          const currentCount = Number(localStorage.getItem("loginCount")) || 0;
          // Increments by 1
          localStorage.setItem("loginCount", currentCount + 1);

          setLoggedIn(true);
          navigate("/");
          window.location.reload();
        } else {
          setErrorMessage("Invalid email or password. Please try again.");
          setShowModal(true);
        }
      })
      .catch(() => {
        setErrorMessage("An error occurred. Please try again later.");
        setShowModal(true);
      });
  };

  const changeLanguage = (language) => {
    setLanguage(language);
    setLanguageState(language);
  };
  <form onSubmit={submitHandler} className={styles.form} autoComplete="off">
  <div className={styles.inputContainer}>
    <input
      type="email"
      placeholder=" "
      className={styles.input}
      onChange={(event) => setEmail(event.target.value)}
      autoComplete="off"  // Add this line
    />
    <label className={styles.label}>{t("email")}</label>
  </div>

  <div className={styles.inputContainer}>
    <input
      type="password"
      placeholder=" "
      className={styles.input}
      onChange={(event) => setPassword(event.target.value)}
      autoComplete="off"  // Add this line
    />
    <label className={styles.label}>{t("password")}</label>
  </div>

  <button type="submit" className={styles.loginButton}>
    {t("login")}
  </button>
</form>
  const getLogo = () => {
    if (languageState === "en") return LogoEn;
    else if (languageState === "zh") return LogoZh;
  };

  return (
    <div className={styles.container}>
      {/* Error Modal */}
      <ErrorModal
        show={showModal}
        onClose={() => setShowModal(false)}
        title={t("login_failed")}
        message={errorMessage}
      />

      {/* Left Side - Logo Placeholder */}
      <div className={styles.logoContainer}>
        <img src={getLogo()} alt="Logo" className={styles.logoText} />
      </div>

      {/* Right Side - Login Form */}
      <div className={styles.loginBox}>
        <h1 className={styles.title}>{t("login")}</h1>
        <form onSubmit={submitHandler} className={styles.form}>
          <div className={styles.inputContainer}>
            <input
              type="email"
              placeholder=" "
              className={styles.input}
              onChange={(event) => setEmail(event.target.value)}
            />
            <label className={styles.label}>{t("email")}</label>
          </div>

          <div className={styles.inputContainer}>
            <input
              type="password"
              placeholder=" "
              className={styles.input}
              onChange={(event) => setPassword(event.target.value)}
            />
            <label className={styles.label}>{t("password")}</label>
          </div>

          <button type="submit" className={styles.loginButton}>
            {t("login")}
          </button>
        </form>

        <div className={styles.linkContainer}>
          <Link to="/register" className={styles.link}>
            {t("create_account")}
          </Link>
          <Link to="/reset-password" className={styles.link}>
            {t("forgot_password")}
          </Link>
        </div>
        <div className={styles.languageSwitcher}>
                <span onClick={() => changeLanguage('en')} className={styles.languageText}>English</span>
                <span onClick={() => changeLanguage('zh')} className={styles.languageText}>中文</span>
            </div>
      </div>
      <DarkModeToggle />
    </div>
  );
};

export default LoginForm;
